import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { IconSettingsComponent } from '@sukna/shared';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { IconXComponent } from '@sukna/shared';
import { IconSunComponent } from '@sukna/shared';
import { IconMoonComponent } from '@sukna/shared';
import { IconLaptopComponent } from '@sukna/shared';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'setting',
    templateUrl: './theme-customizer.html',
    imports: [FormsModule, NgClass, NgScrollbarModule, IconSettingsComponent, IconXComponent, IconSunComponent, IconMoonComponent, IconLaptopComponent,TranslateModule],
})
export class ThemeCustomizerComponent {
    store: any;
    showCustomizer = false;
    constructor(
        public storeData: Store<any>,
        public router: Router,
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    reloadRoute() {
        window.location.reload();
        this.showCustomizer = true;
    }
}
